<fu-icon iconName="failed" size="64" data-testid="wallet_details_failed_icon">
</fu-icon>

<kr-wallet-card
  [wallet]="wallet()"
  large
  data-testid="wallet_details_failed_wallet_card" />

<div
  class="kr-details kr-details_center"
  data-testid="wallet_details_failed_container">
  <p
    class="kr-delete-wallet-failed__message"
    translate="deleteWallet.failed.title"
    [translateParams]="{ name: wallet().name }"
    data-testid="wallet_details_failed_title"></p>

  <label
    class="kr-details__label"
    translate="deleteWallet.failed.label"
    data-testid="wallet_details_failed_label">
  </label>

  <span
    class="kr-details__value kr-details_danger"
    data-testid="wallet_details_failed_error_message">
    {{ errorMessage() }}
  </span>
</div>

<p
  class="kr-details__label"
  translate="deleteWallet.failed.message"
  data-testid="wallet_details_failed_message"></p>

<button
  type="button"
  fuButton
  size="m"
  uiType="primary"
  (click)="closed.emit()"
  translate="deleteWallet.btn.close"
  data-testid="wallet_details_failed_close_button"></button>
